<h4 class="card-title">Evaluaciones Cognitivo - Laboral <button class="btn btn-info waves-effect btn-sm btn-rounded" [routerLink]="['/dashboard/create-custom-test']">Crear nueva</button></h4>

<div class="col-12">
  <div class="form-group form-material">
      <select [(ngModel)]="groupFilter" class="form-control custom-select">
          <option *ngFor="let group of groupsWithQty" [value]="group._id">{{group.title}}: <b><b>[{{group.qty}}]</b></b></option>
      </select>
      <span class="help-block text-muted"><small>Grupo de pruebas</small></span>
  </div>
</div>


<table class="tests-table table" >
    <thead>
        <tr>
            <th >Titulo</th>
            <th >Grupo</th>
            <th *ngIf="user && user.role == 'admin'" >Activo sistema</th>
            <th class="text-center" >Exportar/Borrar</th>
        </tr>
    </thead>
    
    <tbody>
        <tr *ngFor="let test of tests | testGroup: groupFilter; index as i">
            <td >{{test.title}}</td>
            <td class="footable-visible">{{test.groupName}}</td>
            <td *ngIf="user && user.role == 'admin'" class="footable-visible pointer" (click)="toggleVisibility(test)" ><b>{{test.active ? 'SI' : 'NO'}}</b></td>
            <td class="footable-visible footable-last-column text-center">
                <button title="Editar" *ngIf="user && user.role == 'admin' || user && user._id == test.userId" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " [routerLink]="['/dashboard/create-custom-test']" [queryParams]="{editingId: test._id}" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button title="Exportar" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " [routerLink]="['/dashboard/create-custom-test']" [queryParams]="{editingId: test._id, duplicate: true}" >
                    <label class="mytooltip"><i class="fa fa-files-o" aria-hidden="true"></i>
                        <span class="tooltip-content4">Haz clic para exportar/editar esta prueba<br> y personalizar según tus necesidades.<br> Solo recuerda asignarle un nuevo:<br> Titulo y Grupo de Pruebas, y luego guardar<br> los cambios.</span>
                    </label>
                    <!-- <i class="fa fa-files-o" aria-hidden="true"></i> -->
                </button>

                
                <button title="Eliminar" *ngIf="user && user.role == 'admin' || user && user._id == test.userId" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(test._id)" ><i class="fa fa-eraser" ></i></button>
            </td>
        </tr>
    </tbody>

</table>